import { whatsappUrl } from "@/lib/share";

// "2h ago" / "3d ago" for the ready-notified stamp
export function agoText(iso) {
  if (!iso) return "";
  const m = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export const daysInShop = (qt) => Math.max(0, Math.floor((Date.now() - new Date(qt.status_changed_at || qt.created_at).getTime()) / 86400000));

// "Your car is ready" WhatsApp message (EN + 中文)
export function readyForCollectionText(qt, shop) {
  const car = [qt.vehicle, qt.plate ? `(${qt.plate})` : ""].filter(Boolean).join(" ") || "vehicle";
  const where = shop.address ? ` at ${shop.address}` : "";
  return [
    `Hi ${qt.customer_name || ""}, good news from *${shop.name}* — your ${car} is ready for collection.`,
    `Job ref ${qt.quote_no}. You may pick it up${where} during opening hours; do let us know your arrival time.`,
    "",
    "您的车辆已完成，可以来取车了。请告知取车时间，谢谢！",
    "",
    "Thank you for choosing us · 谢谢支持！",
  ].join("\n");
}

// One tap: open WhatsApp (synchronously, so popup blockers allow it) — returns false when there is no phone
export function openReadyWhatsApp(qt, shop) {
  if (!qt.customer_phone) return false;
  window.open(whatsappUrl(qt.customer_phone, shop.countryCode, readyForCollectionText(qt, shop)), "_blank", "noopener");
  return true;
}

// Bay calendar helpers
export const fmtDue = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-SG", { weekday: "short", day: "2-digit", month: "short" }) : "");
export const todayIso = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
export const daysOverdue = (iso) => (iso ? Math.floor((new Date(`${todayIso()}T00:00:00`) - new Date(`${iso}T00:00:00`)) / 86400000) : 0); // >0 = past due
